// Hub stores interactive sends as text messages with the original request.
export const getInteractiveOptions = (message) => {
    const interactive = message?.interactive || message?.raw_payload?.request?.interactive;
    const action = interactive?.action;
    if (!action || typeof action !== 'object') return [];
    const label = value => typeof value === 'string' ? value.trim() : '';
    if (interactive.type === 'button') {
        return (Array.isArray(action.buttons) ? action.buttons : [])
            .map(button => ({ title: label(button?.reply?.title) })).filter(option => option.title);
    }
    if (interactive.type === 'list') {
        return (Array.isArray(action.sections) ? action.sections : []).flatMap(section =>
            (Array.isArray(section?.rows) ? section.rows : []).map(row => ({
                title: label(row?.title), description: label(row?.description),
            }))).filter(option => option.title);
    }
    if (interactive.type === 'cta_url') {
        const title = label(action.parameters?.display_text);
        const url = label(action.parameters?.url);
        return title ? [{ title, description: /^https?:\/\//i.test(url) ? url : '' }] : [];
    }
    return [];
};
